import { NSARouterMakerResult } from "namirasoft-account-react";
import { SlackSenderLayout } from "../SlackSenderLayout";
import { SlackSenderEntities } from "../SlackSenderEntities";
import { SlackSenderRouterProps } from "../SlackSenderRouterProps";

export interface ProviderListPageProps extends NSARouterMakerResult, SlackSenderRouterProps { }

function ProviderListPage(props: ProviderListPageProps)
{
	return (
		<SlackSenderLayout {...props}
			action={{
				description: " This section displays all Slack providers you have created with their basic information.",
			}}
			pages={{
				entity: SlackSenderEntities.provider(props),
				list: {
					ui: {}
				}
			}}
		>
			<></>
		</SlackSenderLayout>
	);
}

export default ProviderListPage;